<div class="grid">
  <div class="col">
    @if (schoolName) {
      <div class="float-left padding-top-2">
        <label class="text-bold">Exclusions from {{ schoolName }}</label>
      </div>
    }
    <div class="float-right">
      <div class="float-left fields-separation">
        <label class="text-bold" id="lblShow">Show</label>
        <p-select
          [options]="showExclusionsAcademicYearOptions"
          id="selectlist"
          (onChange)="filterExclusionByAcademicYear()"
          [(ngModel)]="selectedExclusionAcademicYearOption"
          ariaLabelledBy="lblShow"
          #showDropDown
        ></p-select>
      </div>
      <div class="float-right whitespace">
        <label class="text-bold" id="lblSortby">Sort by</label>
        <p-select
          [options]="exclusionsListSortByOptions"
          id="sortlist"
          (onChange)="sortExclusions()"
          [(ngModel)]="selectedExclusionsSortOption"
          ariaLabelledBy="lblSortby"
          #sortOptionsDropDown
        ></p-select>
      </div>
    </div>
  </div>
</div>
<p-table
  #allExclusionsList
  [value]="filteredExclusions"
  [rows]="50"
  [rowsPerPageOptions]="[50, 100, 150]"
  [paginator]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showCurrentPageReport]="true"
  selectionMode="single"
  (onRowSelect)="onRowSelect($event, false, exclusionsEditingEnabled)"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="verticle-header-align overflow-wrap">Exclusion Category</th>
      <th class="verticle-header-align overflow-wrap">Primary Reason</th>
      <th class="verticle-header-align overflow-wrap">Start Date</th>
      <th class="verticle-header-align overflow-wrap">End Date</th>
      <th class="verticle-header-align overflow-wrap">Meetings</th>
      <th class="verticle-header-align overflow-wrap">Supporting Documents</th>
      <th class="width-ten" [ariaHidden]="true"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-filteredExclusions let-i="rowIndex">
    <tr [pSelectableRow]="filteredExclusions">
      @if (!noExclusionsFoundMessage) {}
      <td class="overflow-wrap">
        {{ filteredExclusions.category }}
      </td>
      <td class="overflow-wrap">{{ filteredExclusions.primaryReason }}</td>
      <td class="overflow-wrap">
        {{ filteredExclusions.startDate | date: "dd/MM/yyyy" }}
      </td>
      <td class="overflow-wrap">
        {{ filteredExclusions.endDate | date: "dd/MM/yyyy" }}
      </td>
      <td>{{ filteredExclusions.meetingFlag }}</td>
      <td>
        @if (filteredExclusions.documentCount === 0) {
          <div>-</div>
        } @else {
          <a
            href="#"
            (click)="
              showExclusionDetailsSection(
                filteredExclusions.exclusionId,
                (accordionActiveState = true),
                exclusionsEditingEnabled
              )
            "
            >{{ filteredExclusions.documentCount }}</a
          >
        }
      </td>
      <td>
        <div class="split-button-container-primary">
          <p-splitButton
            label="Edit"
            (onClick)="
              showExclusionDetailsSection(
                filteredExclusions.exclusionId,
                (accordionActiveState = false),
                exclusionsEditingEnabled
              )
            "
            value="Edit"
            [model]="splitActionButtons[i]"
            attr.ri="{{ i }}"
            (onDropdownClick)="findTableRowIndex(i)"
            (keydown.Tab)="autoCloseSplitButton($event)"
            #editExclusionButton
          >
          </p-splitButton>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    @if (noExclusionsFoundMessage) {
      <tr>
        <td [attr.colspan]="7">
          No exclusion records created for {{ studentName }}
        </td>
      </tr>
    }
  </ng-template>
</p-table>
<br />
@if (!isStudentOffRoll) {
  <div>
    @if (!isExclusionPermOrAper) {
      <button
        title="Add Exclusion"
        label="Add Exclusion"
        pButton
        (click)="
          showExclusionDetailsSection(0, false, exclusionsEditingEnabled)
        "
        class="button-custom-color float-right"
        #addExclusionButton
      ></button>
    }
  </div>
}
